"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Svg24OrderHotbagFill = function Svg24OrderHotbagFill(_ref) {
  var fill = _ref.fill,
      useDefaultColors = _ref.useDefaultColors,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["fill", "useDefaultColors", "title"]);

  return _react.default.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: useDefaultColors ? 'none' : fill,
    "aria-hidden": title === null || typeof title !== 'string' || title.length === 0
  }, props), _react.default.createElement("title", null, title), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 5h2a2 2 0 0 1 2 2v9.864c0 .397 0 .786-.016 1.136H4.016C4 17.65 4 17.26 4 16.864V7a2 2 0 0 1 2-2h2v-.5A2.5 2.5 0 0 1 10.5 2h3A2.5 2.5 0 0 1 16 4.5V5zm-2.5-1a.5.5 0 0 1 .5.5V5h-4v-.5a.5.5 0 0 1 .5-.5h3zm.765 5.2a2.5 2.5 0 0 1 2.21 1.328c1.12 2.131-.396 4.272-2.398 4.272H12.53a.71.71 0 0 1-.516-.208l-1.526-1.536a.282.282 0 0 1-.07-.169c0-.139.11-.248.238-.248h3.4a.635.635 0 0 0 .634-.644.635.635 0 0 0-.644-.634H9.101a.667.667 0 0 1-.505-.208L7.069 9.616A.281.281 0 0 1 7 9.448c0-.139.109-.248.238-.248h7.027z",
    fill: useDefaultColors ? '#191919' : fill
  }), _react.default.createElement("path", {
    d: "M4.536 20h14.928a4 4 0 0 1-1.648 1.564c-.543.277-1.082.365-1.54.402-.416.034-.907.034-1.412.034H9.136c-.505 0-.996 0-1.412-.034-.458-.037-.997-.125-1.54-.402A4 4 0 0 1 4.536 20z",
    fill: useDefaultColors ? '#191919' : fill
  }));
};

Svg24OrderHotbagFill.propTypes = {
  title: _propTypes.default.string,
  fill: _propTypes.default.string,
  useDefaultColors: _propTypes.default.bool
};
var _default = Svg24OrderHotbagFill;
exports.default = _default;